import * as React from 'react';
import {PuzzleBoard} from "./PuzzleBoard";
import {EUnwrapStage} from "../../../models/UIModel";
import {inject, observer} from "mobx-react";
import UIStore from "../../../stores/UIStore";
import RStore from "../../../stores/RStore";
import PStore from "../../../stores/PStore";
import {RecipientInfo} from "../../../../libs/RecipientInfo";
import {EMode} from "../../../../libs/Mode";
import {Global} from "../../../../libs/Global";

// props for unwrap gifts
interface IUnwrapGiftProps {
    UI_STORE?:UIStore;
    R_STORE?:RStore;
    P_STORE?:PStore;
}

/**
 * Container where all logic for unwrapping gift by doing puzzle, is stored
 */

@inject('UI_STORE', 'R_STORE', 'P_STORE')
@observer
export class UnwrapGift extends React.Component<IUnwrapGiftProps, any> {

    public render():any {
        return (
            <div>
                <h1>Unwrap Your Gift</h1>
                <p>Hey {this.props.R_STORE!.r.recipientRecord.name}!</p>
                <PuzzleBoard
                    word={this.props.P_STORE!.p.puzzleRecord.word}
                    lastSavedWord={this.props.R_STORE!.r.recipientRecord.puzzleSavePoint}
                    puzzleCompleteHandler={()=>{this.onPuzzleComplete_Handler()}}/>
            </div>
        );
    }

    /**
     * Handler for when puzzle is complete
     */
    public async onPuzzleComplete_Handler() {
        // we are now complete this stage
        this.props.UI_STORE?.setStage(EUnwrapStage.Complete);

        // if not testing
        if (Global.mode != EMode.Testing) {
            // mark gift as as redeemed for recipient
            await RecipientInfo.updateRecordAsRedeemed(this.props.R_STORE!.r.recipientRecord.id);
        }

    }

}



